import { render, staticRenderFns } from "./ButtonBlob.vue?vue&type=template&id=55bfa746"
import script from "./ButtonBlob.vue?vue&type=script&lang=js"
export * from "./ButtonBlob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports